import GenericDialog from "./generic";
import { deviceSet } from "api/device";
import { Device, DeviceSetBody } from "api/types/device";
import { DeviceConfiguration } from "models/devices/configuration";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import ElectricityConfigurationForm from "widgets/forms/devices/configuration/electricity";
import GasConfigurationForm from "widgets/forms/devices/configuration/gas";
import LevelConfigurationForm from "widgets/forms/devices/configuration/level";
import TemperatureConfigurationForm from "widgets/forms/devices/configuration/temperature";
import WaterConfigurationForm from "widgets/forms/devices/configuration/water";

const DeviceConfigurationDialog = (props: {
  device: Device;
  config?: DeviceConfiguration;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const {device, isOpen, onClose, onSuccess, config} = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const doDeviceSet = async (formData: any) => {
    const body: DeviceSetBody = {
      snr: device?.snr,
    };
    if (formData?.dailyUsageLimit) {
      body.dailyUsageLimit = formData.dailyUsageLimit;
    }
    if (formData?.triggerLow) {
      body.triggerLow = formData.triggerLow;
    }
    if (formData?.triggerHigh) {
      body.triggerHigh = formData.triggerHigh;
    }
    if (formData?.missingTime) {
      body.missingTime = formData.missingTime;
    }
    if (formData?.lowLevelPercentage) {
      body.lowLevelPercentage = formData.lowLevelPercentage;
    }
    handleSet(body);
  };

  const handleSet = async (body: DeviceSetBody) => {
    dispatch(setLoading(true));
    const { status, isLoading } = await deviceSet(body);
    dispatch(setLoading(isLoading));

    if (status && status === 200) {
      onSuccess();
    }
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      title={t("dialog.device.info.title.configuration")}
      onExit={onClose}
      size="lg"
    >
      {config && config.units === "water" && (
        <WaterConfigurationForm
          submit={doDeviceSet}
          onClose={onClose}
          values={{ dailyUsageLimit: device?.dailyUsageLimit }}
        />
      )}
      {config && config.units === "electricity" && (
        <ElectricityConfigurationForm
          submit={doDeviceSet}
          onClose={onClose}
          values={{ dailyUsageLimit: device?.dailyUsageLimit }}
        />
      )}
      {config && config.units === "gas" && (
        <GasConfigurationForm
          submit={doDeviceSet}
          onClose={onClose}
          values={{ dailyUsageLimit: device?.dailyUsageLimit }}
        />
      )}
      {config && config.units === "temperature" && (
        <TemperatureConfigurationForm
          submit={doDeviceSet}
          onClose={onClose}
          values={{
            triggerLow: device?.triggerLow || "",
            triggerHigh: device?.triggerHigh || "",
            missingTime: device?.missingTime || undefined
          }}
        />
      )}
      {config && config.units === "level" && (
        <LevelConfigurationForm
          submit={doDeviceSet}
          onClose={onClose}
          values={{ lowLevelPercentage: device?.lowLevelPercentage }}
        />
      )}
    </GenericDialog>
  );
};

export default DeviceConfigurationDialog;
  